"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faInfoCircle = require("@fortawesome/pro-regular-svg-icons/faInfoCircle");

var _classnames = _interopRequireDefault(require("classnames"));

var _Help = _interopRequireDefault(require("../Help"));

var _Error = _interopRequireDefault(require("../Error"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var FormGroup = function FormGroup(_ref) {
  var name = _ref.name,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      help = _ref.help,
      error = _ref.error,
      children = _ref.children,
      className = _ref.className,
      tooltip = _ref.tooltip,
      _ref$charactercount = _ref.charactercount,
      charactercount = _ref$charactercount === void 0 ? false : _ref$charactercount,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('form-group', _defineProperty({
      'has-error': error
    }, "".concat(className), className))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex justify-content-between align-items-center"
  }, label.length > 0 && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: name,
    className: (0, _classnames["default"])({
      'mb-1': !help,
      'mb-0': help,
      required: required === true
    })
  }, label), tooltip && /*#__PURE__*/_react["default"].createElement("span", {
    "data-tooltip": tooltip,
    className: (0, _classnames["default"])('ml-2', {
      'tooltip-wrap': tooltip.length > 50
    })
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faInfoCircle.faInfoCircle
  }))), charactercount !== false && /*#__PURE__*/_react["default"].createElement("p", {
    className: "mb-0",
    "data-testid": "".concat(name, "_character-count")
  }, "Character Count: ", /*#__PURE__*/_react["default"].createElement("strong", null, charactercount))), help && /*#__PURE__*/_react["default"].createElement(_Help["default"], {
    className: "mt-0 mb-2",
    id: "".concat(name, "Help"),
    help: help
  }), children, error && /*#__PURE__*/_react["default"].createElement(_Error["default"], {
    error: error,
    name: name
  }));
};

FormGroup.displayName = 'FormGroup';
FormGroup.propTypes = {
  name: _propTypes["default"].string.isRequired,
  help: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  children: _propTypes["default"].any,
  className: _propTypes["default"].string
};
var _default = FormGroup;
exports["default"] = _default;